import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSportsList } from "../../../utilities/api/sports/indext";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}
type SportsListType = {
  createdAt: string;
  name: string;
  updatedAt: string;
  id: string;
};

const initialState = {
  AllSportsData: [] as SportsListType[],
  sportErrorMessage: {} as ErrorMessageType,
};

export const AllSportsList = createAsyncThunk(
  "SportList/AllSportsList",
  (payload: any) => GetSportsList(payload)
);

const SportsListSlice = createSlice({
  name: "SportsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(AllSportsList.fulfilled, (state, action: PayloadAction<any>) => {
        if (action?.payload?.statusCode === 200) {
          state.AllSportsData = action.payload.data.rows.map((item: any) => ({
            name: item.name,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
            id: item.id,
            isActive: item.isActive ? "Active" : "Inactive",
          }));
        }
      })

      .addCase(AllSportsList.rejected, (state, action) => {
        state.sportErrorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default SportsListSlice.reducer;
